import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Terms from "../pages/terms/page";
import Contact from "../pages/contact/page";
import TrademarkGuidelines from "../pages/trademark-guidelines/page";
import LicenseApplication from "../pages/license-application/page";
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/trademark-guidelines",
    element: <TrademarkGuidelines />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/license-application",
    element: <LicenseApplication />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;